/**
 * Video section: reduced-motion handling and playback controls.
 */
(function () {
  function pauseEmbed(iframe) {
    if (!iframe || !iframe.contentWindow) {
      return;
    }

    const host = iframe.dataset.videoHost;

    if (host === "youtube") {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "pauseVideo", args: "" }),
        "*",
      );
    } else if (host === "vimeo") {
      iframe.contentWindow.postMessage(
        JSON.stringify({ method: "pause" }),
        "*",
      );
    }
  }

  function playEmbed(iframe) {
    if (!iframe || !iframe.contentWindow) {
      return;
    }

    const host = iframe.dataset.videoHost;

    if (host === "youtube") {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "playVideo", args: "" }),
        "*",
      );
    } else if (host === "vimeo") {
      iframe.contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
    }
  }

  function initSection(section) {
    const autoplay = section.dataset.autoplay === "true";
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const iframe = section.querySelector("[data-video-embed]");
    const video = section.querySelector(".video-section__media > video");
    const pauseButton = section.querySelector("[data-video-pause]");
    const resumeButton = section.querySelector("[data-video-resume]");

    if (iframe) {
      const nextSrc =
        autoplay && !reducedMotion
          ? iframe.dataset.srcAutoplay
          : iframe.dataset.srcStatic;

      if (nextSrc) {
        iframe.src = nextSrc;
      }
    }

    if (video && autoplay && !reducedMotion) {
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(function () {});
      }
    }

    if (pauseButton) {
      pauseButton.addEventListener("click", function () {
        if (video) {
          video.pause();
        }

        pauseEmbed(iframe);
        pauseButton.hidden = true;

        if (resumeButton) {
          resumeButton.hidden = false;
        }
      });
    }

    if (resumeButton) {
      resumeButton.addEventListener("click", function () {
        if (video) {
          video.play().catch(function () {});
        } else {
          playEmbed(iframe);
        }

        resumeButton.hidden = true;

        if (pauseButton) {
          pauseButton.hidden = false;
        }
      });
    }
  }

  function initAll(root) {
    root.querySelectorAll("[data-video-section]").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
